<script>
import templatable from "@/mixins/templatable";
import LotListAndFilters from "@/components/LotListAndFilters";
import {mapActions, mapMutations, mapState, mapGetters} from "vuex";
import {LOT_LIST_DEFAULT_LIMIT, LOT_LIST_DEFAULT_PAGE} from "@/constants";
import {updateLotsRoute} from "@/helpers";

export default {
  name: "LotsIMadeBid",
  components: {
    LotListAndFilters
  },
  mixins: [templatable('iMadeBidsLotListTemplate')],
  data: () => ({
    template: `
        [[template]]
    `
  }),
  computed: {
    ...mapState(['lotQueryParams']),
    ...mapGetters(['lotStatuses', 'lots'])
  },
  watch: {
    '$route.query': {
      // immediate: true,
      handler() {
        this.updateData()
      },
    },
  },
  methods: {
    ...mapActions(['getLots', 'getDepartments']),
    ...mapMutations(['setLotFilters', 'emptyLotFilters', 'emptyLots']),
    updateFilters(filters){
      filters.page = LOT_LIST_DEFAULT_PAGE;
      this.setLotFilters(filters)
      updateLotsRoute()
    },
    updateData() {
      this.emptyLotFilters();
      this.setLotFilters({
        ...this.$route.query,
        auction_uuid: this.auctionUuid,
        favorites: 1
      });
      this.getLots();
      this.getDepartments();
    }
  },
  mounted() {
    this.updateData()
  },
  beforeDestroy() {
    this.emptyLots();
  },
  destroyed() {
    this.emptyLotFilters();
    this.setLotFilters({
      page: LOT_LIST_DEFAULT_PAGE,
      limit: LOT_LIST_DEFAULT_LIMIT
    });
  }
}
</script>

<style scoped>

</style>
